// Using jQuery
(function($) {
  $(document).ready(function() {
    $(".seemore").click(function(e) {
        e.preventDefault();
        const cardList = $(this).parent().parent().find(".cardlist__cardcontainer .card--hidden");

        cardList.each(function(index) {
          $(this).removeClass("card--hidden");
        });

        $(this).hide();
    
    });
  });
}
(jQuery));